var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluviometrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2220 4845 c-437 -54 -860 -233 -1205 -510 -265 -213 -473 -474 -630 -790 -161 -325 -245 -681 -245 -1045 0 -1125 801 -2102 1898 -2314 959 -185 1899 208 2435 1019 249 376 387 838 387 1292 0 622 -248 1228 -680 1662 -381 382 -875 623 -1410 687 -142 17 -409 16 -550 -1z m675 -204 c474 -99 821 -285 1150 -615 333 -334 541 -751 609 -1217 21 -143 21 -475 0 -618 -103 -706 -541 -1313 -1179 -1633 -218 -110 -378 -162 -622 -204 -208 -35 -498 -35 -706 0 -244 42 -404 94 -622 204 -638 320 -1077 927 -1180 1633 -20 143 -20 475 1 618 89 616 434 1158 959 1508 269 180 580 294 940 347 17 2 147 3 290 1 217 -2 277 -6 360 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2405 4060 c-249 -57 -489 -222 -620 -428 l-40 -63 -65 6 c-138 13 -315 -27 -449 -102 -83 -46 -223 -185 -274 -273 -21 -36 -50 -101 -64 -145 -25 -72 -27 -94 -28 -230 0 -130 3 -160 23 -225 84 -270 300 -468 574 -524 68 -14 209 -16 1151 -16 673 0 1094 4 1128 10 124 23 259 116 329 226 95 150 98 364 8 523 -73 127 -215 223 -361 244 l-75 11 -7 80 c-39 452 -365 819 -808 910 -106 22 -317 20 -422 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2443 1822 c-76 -102 -139 -202 -178 -284 -29 -60 -35 -84 -35 -138 0 -153 113 -264 270 -264 82 1 156 31 206 86 50 55 64 95 64 180 0 60 -5 84 -30 137 -49 102 -218 351 -239 351 -4 0 -30 -31 -58 -68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluviometrica);
export default __webpack_public_path__ + "static/media/pluviometrica.5dcfade56324f87b3b5921d5e08fd437.svg";
export { ForwardRef as ReactComponent };